import { campaignServiceInstance, type GetActiveCampaignResponse } from "@/services/campaign.service";
import { createContext, useCallback, useEffect, useState, type ReactNode } from "react";

type CampaignContextProps = {
  campaign: GetActiveCampaignResponse | undefined
}

export const CampaignContext = createContext<CampaignContextProps>({} as CampaignContextProps)

type Props = {
  children: ReactNode
}

export function CampaignContextProvider(props: Props) {
  const { children } = props

  const [campaign, setCampaign] = useState<GetActiveCampaignResponse | undefined>(undefined)

  const getCampaign = useCallback(async () => {
    const data = await campaignServiceInstance.getActive()
    setCampaign(data)
  }, [])

  useEffect(() => {
    getCampaign()
  }, [])

  return (
    <CampaignContext.Provider value={{ campaign }}>
      {children}
    </CampaignContext.Provider>
  )
}